import { create } from 'zustand';

/**
 * Zustand store for the agentic search chat widget.
 * Ephemeral — state lives only in memory, no DB persistence.
 */
export const useAgenticSearchStore = create((set, get) => ({
	// Panel visibility
	isOpen: false,
	setIsOpen: (val) => set({ isOpen: val }),
	toggleOpen: () => set((s) => ({ isOpen: !s.isOpen })),

	// Chat messages: { id, role: 'user'|'assistant', content, type: 'text'|'preview'|'action' }
	messages: [],
	addMessage: (msg) =>
		set((s) => ({
			messages: [...s.messages, { id: `msg_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`, ...msg }],
		})),
	updateLastAssistantMessage: (content) =>
		set((s) => {
			const msgs = [...s.messages];
			for (let i = msgs.length - 1; i >= 0; i--) {
				if (msgs[i].role === 'assistant' && msgs[i].type === 'text') {
					msgs[i] = { ...msgs[i], content };
					break;
				}
			}
			return { messages: msgs };
		}),

	// Streaming state
	isStreaming: false,
	streamingContent: '',
	setStreaming: (val) => set({ isStreaming: val, ...(val ? {} : { streamingContent: '' }) }),
	appendStreamContent: (chunk) => set((s) => ({ streamingContent: s.streamingContent + chunk })),

	// Extracted search params from AI
	extractedParams: null,
	setExtractedParams: (params) => set({ extractedParams: params }),

	// Preview state
	previewResults: null,
	setPreviewResults: (results) => set({ previewResults: results }),
	isLoadingPreview: false,
	setIsLoadingPreview: (val) => set({ isLoadingPreview: val }),

	// Chat phase: idle → conversing → awaiting_approval (maps) → previewing (hr) → executing → completed
	phase: 'idle',
	setPhase: (phase) => set({ phase }),

	// Reset everything for a new conversation
	resetChat: () =>
		set({
			messages: [],
			isStreaming: false,
			streamingContent: '',
			extractedParams: null,
			previewResults: null,
			isLoadingPreview: false,
			phase: 'idle',
		}),

	/**
	 * Get messages in the format expected by the backend (for conversation history).
	 * Only includes text messages, strips IDs and types.
	 */
	getMessagesForApi: () => {
		return get()
			.messages.filter((m) => m.type === 'text')
			.map(({ role, content }) => ({ role, content }));
	},
}));
